import React from 'react'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    invert?: boolean
    inherit?: boolean
  }
>

const LoadingIndicator = ({className, invert = false, inherit = false, ...props}: Props) => (
  <span {...props} className={cn('LoadingIndicator', {invert, inherit}, className)}>
    <span className="LoadingIndicator__spinner" />
  </span>
)

export default LoadingIndicator
